function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1.66699,
  y: 2.41211,
  width: 35.1768,
  height: 61.1769,
  rx: 8.58676,
  fill: "white",
  stroke: "#4F4C4D",
  strokeWidth: 3
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.66699 52.6641H36.8438V59.2108C36.8438 61.6284 34.8839 63.5887 32.4662 63.5887H6.04459C3.62691 63.5887 1.66699 61.6284 1.66699 59.2108V52.6641Z",
  fill: "#FFCC00",
  stroke: "#4F4D4C",
  strokeWidth: 3
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.2552 60.3109C20.4694 60.3109 21.4538 59.3327 21.4538 58.1262C21.4538 56.9196 20.4694 55.9414 19.2552 55.9414C18.041 55.9414 17.0566 56.9196 17.0566 58.1262C17.0566 59.3327 18.041 60.3109 19.2552 60.3109Z",
  fill: "white",
  stroke: "#4F4D4C",
  strokeWidth: 3
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.0566 7.875H21.4538",
  stroke: "#4F4D4C",
  strokeWidth: 3
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.3146 20.8047C25.7557 20.8047 30.1671 25.2471 30.1671 30.7266C30.1671 36.2061 25.7557 40.6486 20.3146 40.6486C14.8734 40.6486 10.4619 36.2061 10.4619 30.7266C10.4619 25.2471 14.8734 20.8047 20.3146 20.8047Z",
  fill: "#FFCC00",
  stroke: "#4F4C4D",
  strokeWidth: 3
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.4534 31.9076H19.2549V26.4453H21.4534V31.9076Z",
  fill: "#4F4D4C"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.3007 35.1631L18.7461 33.6085L22.6085 29.7461L24.1631 31.3007L20.3007 35.1631Z",
  fill: "#4F4D4C"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.9639 33.6085L20.4093 35.1631L16.5469 31.3007L18.1015 29.7461L21.9639 33.6085Z",
  fill: "#4F4D4C"
});

var SvgIconTymeApp = function SvgIconTymeApp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 39,
    height: 66,
    viewBox: "0 0 39 66",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconTymeApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-tyme-app.a4d06cec.svg";
export { ForwardRef as ReactComponent };